(() => {
  const BUNDLE_SELECTOR = '[data-kalaboost-bundle]';
  const INPUT_SELECTOR = '[data-kalaboost-bundle] input[type="radio"]';
  const PRICES_SELECTOR = '[data-kalaboost-atc-prices]';
  const REWARDS_TEMPLATE_SELECTOR = 'template[data-kalaboost-bundle-rewards]';
  const REWARD_SELECTOR = '[data-kalaboost-bundle-reward]';
  const REWARDS_CLASS = 'kalaboost-bundle-option__rewards';
  const OPTION_SELECTOR = '.kalaboost-bundle-option';
  const PERKS_SELECTOR = '.kalaboost-bundle-option__perks';
  const QUANTITY_UPDATE_EVENT = 'quantity-selector:update';
  const PRODUCT_SELECT_EVENT = 'shopify:product:select';

  // Keeps the shopper's choice when the theme re-renders the section on variant change.
  const lastSelected = new WeakMap();

  const getRoot = (element) => element.closest('.shopify-section') || document;

  const readQuantity = (input) => {
    const parsed = Number.parseInt(input.dataset.quantity, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  };

  const syncProductForm = (bundle, quantity) => {
    const root = getRoot(bundle);
    const form = root.querySelector('product-form-component form');
    if (!form) return;

    let quantityInput = form.querySelector('input[name="quantity"]');

    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      form.appendChild(quantityInput);
    }

    quantityInput.value = String(quantity);

    const stickyAddToCart = root.querySelector('sticky-add-to-cart');
    if (stickyAddToCart) {
      stickyAddToCart.dataset.initialQuantity = String(quantity);
    }

    const quantityEvent = new Event(QUANTITY_UPDATE_EVENT, { bubbles: true });
    quantityEvent.detail = { quantity };
    form.dispatchEvent(quantityEvent);
  };

  const syncButtonPrice = (bundle, input) => {
    const containers = getRoot(bundle).querySelectorAll(PRICES_SELECTOR);
    if (containers.length === 0) return;

    const price = input.dataset.price || '';
    const compare = input.dataset.compare || '';
    const discount = Number.parseInt(input.dataset.discount, 10) || 0;

    containers.forEach((container) => {
      const totalElement = container.querySelector('[data-kalaboost-atc-total]');
      const compareElement = container.querySelector('[data-kalaboost-atc-compare]');

      if (totalElement && price !== '') totalElement.textContent = price;

      if (compareElement) {
        const showCompare = discount > 0 && compare !== '' && compare !== price;
        compareElement.textContent = showCompare ? compare : '';
        compareElement.hidden = !showCompare;
      }
    });
  };

  // The thresholds live on the bundle, the totals on each offer, so the gifts
  // are copied from the template into every card that reaches the amount.
  const renderRewards = (bundle) => {
    const template = bundle.querySelector(REWARDS_TEMPLATE_SELECTOR);
    if (!template) return;

    bundle.querySelectorAll(`.${REWARDS_CLASS}`).forEach((panel) => panel.remove());

    bundle.querySelectorAll('input[type="radio"]').forEach((input) => {
      const option = input.closest(OPTION_SELECTOR);
      if (!option) return;

      const total = Number.parseInt(input.dataset.total, 10) || 0;
      const rewards = Array.from(template.content.cloneNode(true).querySelectorAll(REWARD_SELECTOR));
      const unlocked = rewards.filter((reward) => {
        const threshold = Number.parseInt(reward.dataset.threshold, 10) || 0;
        return threshold > 0 && total >= threshold;
      });

      if (unlocked.length === 0) return;

      const panel = document.createElement('span');
      panel.className = REWARDS_CLASS;

      unlocked.forEach((reward) => {
        reward.hidden = false;
        panel.appendChild(reward);
      });

      const perks = option.querySelector(PERKS_SELECTOR);
      if (perks) {
        option.insertBefore(panel, perks);
      } else {
        option.appendChild(panel);
      }
    });
  };

  const syncSelection = (bundle, input) => {
    lastSelected.set(bundle, readQuantity(input));
    syncProductForm(bundle, readQuantity(input));
    syncButtonPrice(bundle, input);
  };

  const applySelection = (bundle) => {
    renderRewards(bundle);

    const inputs = Array.from(bundle.querySelectorAll('input[type="radio"]'));
    if (inputs.length === 0) return;

    const remembered = lastSelected.get(bundle);
    let checked = null;

    if (remembered != null) {
      checked = inputs.find((input) => readQuantity(input) === remembered) || null;
    }

    if (!checked) checked = inputs.find((input) => input.checked) || inputs[0];

    checked.checked = true;
    syncSelection(bundle, checked);
  };

  const init = (root) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    scope.querySelectorAll(BUNDLE_SELECTOR).forEach(applySelection);
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.(INPUT_SELECTOR);
    if (!input) return;

    const bundle = input.closest(BUNDLE_SELECTOR);
    if (bundle) syncSelection(bundle, input);
  });

  document.addEventListener(PRODUCT_SELECT_EVENT, (event) => {
    const target = event.target instanceof Element ? getRoot(event.target) : document;
    requestAnimationFrame(() => init(target));
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  document.addEventListener('shopify:block:select', (event) => {
    const input = event.target.querySelector?.('input[type="radio"]');
    if (!input) return;

    input.checked = true;
    const bundle = input.closest(BUNDLE_SELECTOR);
    if (bundle) syncSelection(bundle, input);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
